module.exports = __webpack_public_path__ + "img/C04HorsemanShip_ua.4d8e6cf2.webp";